<template>
    <div class="login-page">
        <!-- 背景装饰元素 - 教育风格 -->
        <div class="bg-decoration bg-circle-1"></div>
        <div class="bg-decoration bg-circle-2"></div>
        <div class="bg-decoration bg-books">
            <i class="fas fa-book-open"></i>
            <i class="fas fa-graduation-cap"></i>
            <i class="fas fa-pencil-alt"></i>
        </div>

        <!-- 语言切换 -->
<!--        <div class="language-switcher">-->
<!--            <el-select v-model="language" placeholder="选择语言" size="small" style="width: 120px;">-->
<!--                <el-option label="简体中文" value="zh"></el-option>-->
<!--                <el-option label="English" value="en"></el-option>-->
<!--                <el-option label="日本語" value="jp"></el-option>-->
<!--            </el-select>-->
<!--        </div>-->

        <div class="login-content">
            <el-row class="login-container" type="flex" justify="center" align="middle">
                <el-col :xs="24" :sm="24" :md="12" :lg="10" :xl="8">
                    <!-- 品牌介绍区域 -->
                    <div class="brand-section">
                        <div class="brand-header">
                            <div class="brand-logo">
                                <img src="@/assets/logo.jpg" alt="Coco ABC" class="logo-img" />
                                <div class="logo-text">COCO<span style="color: #4caf50;">教育</span></div>
                            </div>
                            <h1 class="brand-title">教育机构数字化管理平台</h1>
                        </div>

                        <ul class="features">
                            <li><i class="fas fa-users"></i> 智能学生管理，全面掌握学习动态</li>
                            <li><i class="fas fa-chalkboard-teacher"></i> 教师协同办公，提升教学效率</li>
                            <li><i class="fas fa-chart-line"></i> 数据分析驱动，精准教学决策</li>
                            <li><i class="fas fa-laptop"></i> 多端同步管理，随时随地办公</li>
                        </ul>
                    </div>
                </el-col>

                <el-col :xs="24" :sm="24" :md="12" :lg="10" :xl="8">
                    <!-- 登录表单区域 -->
                    <div class="login-section">
                        <el-card class="login-card" shadow="always">
                            <div slot="header" class="login-header">
                                <h2 class="login-title">后台管理系统登录</h2>
                                <p class="login-subtitle">欢迎回来，请登录您的账户</p>
                            </div>
                            <el-form
                                :model="loginForm"
                                :rules="loginRules"
                                ref="loginForm"
                                class="login-form"
                                @submit.native.prevent="handleLogin"
                            >
                                <el-form-item prop="tenantId" label="租户：">
                                    <el-select style="width: 80%;" v-model="loginForm.tenantId" placeholder="请选择租户">
                                        <el-option v-for="item in tenantList" :label="item.companyName" :key="item.companyName"
                                                   :value="item.tenantId">
                                            {{ item.companyName }}
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item prop="username">
                                    <el-input
                                        v-model="loginForm.username"
                                        placeholder="请输入用户名或手机号"
                                        prefix-icon="el-icon-user"
                                        maxlength="11"
                                        size="medium"
                                        clearable
                                    >
                                    </el-input>
                                </el-form-item>

                                <el-form-item prop="password">
                                    <el-input
                                        v-model="loginForm.password"
                                        type="password"
                                        placeholder="请输入密码"
                                        prefix-icon="el-icon-lock"
                                        size="medium"
                                        show-password
                                        @keyup.enter.native="handleLogin"
                                    >
                                    </el-input>
                                </el-form-item>

                                <el-form-item>
                                    <div class="form-footer">
                                        <el-checkbox v-model="rememberMe">记住登录状态</el-checkbox>
                                        <el-link type="primary" :underline="false" @click="showForgetDialog">
                                            忘记密码？
                                        </el-link>
                                    </div>
                                </el-form-item>

                                <el-form-item>
                                    <el-button
                                        type="success"
                                        class="login-btn"
                                        :loading="loading"
                                        @click="handleLogin"
                                        native-type="submit"
                                    >
                                        {{ loading ? '登录中...' : '进入系统' }}
                                    </el-button>
                                </el-form-item>
                            </el-form>

                            <div class="footer-links">
                                <span>还没有账户？</span>
                                <el-link type="success" :underline="false" @click="showRegisterDialog">联系管理员</el-link>
                                <el-divider direction="vertical"></el-divider>
                                <el-link type="success" :underline="false" @click="showHelpDialog">获取帮助</el-link>
                            </div>
                        </el-card>
                    </div>
                </el-col>
            </el-row>
        </div>

        <div class="copyright">
            <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">浙ICP备2026009810号</a>
        </div>
    </div>
</template>

<script>
import {reqListSysTenant} from "@/api/system/tenant";

export default {
    name: 'Login',
    async created(){
        await this.loadTenant();
    },
    data () {
        const validatePassword = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else if (value.length < 6) {
                callback(new Error('密码长度不能少于6位'));
            } else {
                callback();
            }
        };

        return {
            tenantList:[],
            language: 'zh',
            loginForm: {
                username: '',
                password: '',
                tenantId:'001296',
            },
            rememberMe: false,
            loading: false,
            loginRules: {
                username: [
                    { required: true, message: '请输入用户名或手机号', trigger: 'blur' },
                    { min: 3, message: '用户名长度不能少于3个字符', trigger: 'blur' }
                ],
                password: [
                    { required: true, validator: validatePassword, trigger: 'blur' }
                ]
            }
        }
    },

    mounted () {
        const savedUsername = localStorage.getItem('savedUsername');
        if (savedUsername) {
            this.loginForm.username = savedUsername;
            this.rememberMe = true;
        }

        document.addEventListener('keydown', this.handleKeyDown);
        this.adjustContentHeight();
        window.addEventListener('resize', this.adjustContentHeight);
    },

    beforeDestroy() {
        document.removeEventListener('keydown', this.handleKeyDown);
        window.removeEventListener('resize', this.adjustContentHeight);
    },

    methods: {
        async loadTenant(){
            let data=await reqListSysTenant({currentPage:1,pageSize:10});
            this.tenantList=data.records
        },
        adjustContentHeight() {
            const loginPage = document.querySelector('.login-page');
            const viewportHeight = window.innerHeight;
            loginPage.style.minHeight = viewportHeight + 'px';

            const loginContent = document.querySelector('.login-content');
            if (loginContent) {
                const contentHeight = loginContent.offsetHeight;
                if (contentHeight < viewportHeight - 80) {
                    loginContent.style.marginTop = ((viewportHeight - contentHeight - 60) / 2) + 'px';
                } else {
                    loginContent.style.marginTop = '40px';
                }
            }
        },

        handleLogin() {
            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    this.loading = true
                    this.$store.dispatch('user/login', this.loginForm)
                        .then(() => {
                            this.$message.success('登录成功，欢迎回来')
                            this.$router.replace('/home')
                        }).catch(() => (this.loading = false))
                } else {
                    return false;
                }
            });
        },

        handleKeyDown(event) {
            if (event.key === 'Enter' && !this.loading) {
                this.handleLogin();
            }
        },

        showForgetDialog() {
            this.$alert(
                '请联系机构管理员或发送邮件至 2607166411@qq.com 重置密码。',
                '忘记密码',
                {
                    confirmButtonText: '确定',
                    type: 'info',
                    customClass: 'forget-password-dialog'
                }
            );
        },

        showRegisterDialog() {
            this.$alert(
                '机构用户注册请联系可可教育客服团队：400-123-4567',
                '账户注册',
                {
                    confirmButtonText: '了解详情',
                    type: 'info',
                }
            );
        },

        showHelpDialog() {
            this.$alert(
                '如需帮助，请访问帮助中心或致电客服热线：400-123-4567',
                '获取帮助',
                {
                    confirmButtonText: '确定',
                    type: 'info'
                }
            );
        },

        handleLanguageChange() {
            const languageNames = {
                'zh': '简体中文',
                'en': '英文',
                'jp': '日文'
            };

            this.$message({
                message: `已切换至${languageNames[this.language]}界面`,
                type: 'info'
            });
        }
    },
    watch: {
        rememberMe(newVal) {
            if (newVal) {
                localStorage.setItem('savedUsername', this.loginForm.username);
            } else {
                localStorage.removeItem('savedUsername');
            }
        },

        language(newVal) {
            this.handleLanguageChange();
        }
    }
}
</script>

<style lang="scss" scoped>
.login-page {
    min-height: 100vh;
    background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 50%, #a5d6a7 100%);
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;

    .bg-decoration {
        position: absolute;
        border-radius: 50%;
        z-index: 0;
    }

    .bg-circle-1 {
        width: 300px;
        height: 300px;
        background: rgba(76, 175, 80, 0.1);
        top: -150px;
        right: -100px;
    }

    .bg-circle-2 {
        width: 200px;
        height: 200px;
        background: rgba(76, 175, 80, 0.08);
        bottom: -80px;
        left: -80px;
    }

    .bg-books {
        position: absolute;
        top: 50%;
        left: 5%;
        font-size: 60px;
        color: rgba(76, 175, 80, 0.08);
        z-index: 0;
        i {
            margin: 20px;
        }
    }

    .language-switcher {
        position: absolute;
        top: 20px;
        right: 20px;
        z-index: 2;
    }

    .login-content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        z-index: 1;
        max-height: calc(100vh - 60px);
    }

    .login-container {
        width: 100%;
        max-width: 1200px;
        display: flex;
        align-items: center;

        .brand-section {
            color: #2e7d32;
            padding: 20px 40px;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .brand-header {
                margin-bottom: 20px;

                .brand-logo {
                    display: flex;
                    align-items: center;
                    margin-bottom: 15px;
                    flex-wrap: wrap;

                    .logo-img {
                        width: 50px;
                        height: 50px;
                        margin-right: 12px;
                        object-fit: contain;
                    }

                    .logo-text {
                        font-size: 26px;
                        font-weight: 700;
                        letter-spacing: 1px;
                        line-height: 1.2;
                        color: #1b5e20;
                    }
                }

                .brand-title {
                    font-size: 30px;
                    font-weight: 700;
                    line-height: 1.2;
                    margin: 0;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: #2e7d32;
                }
            }

            .features {
                list-style: none;
                margin: 0;
                padding: 0;

                li {
                    display: flex;
                    align-items: flex-start;
                    margin-bottom: 12px;
                    font-size: 15px;
                    line-height: 1.5;
                    color: #388e3c;

                    i {
                        color: #4caf50;
                        margin-right: 10px;
                        font-size: 16px;
                        min-width: 20px;
                        margin-top: 2px;
                    }
                }
            }
        }

        .login-section {
            .login-card {
                border-radius: 16px;
                border: none;
                max-height: 500px;
                overflow: hidden;

                ::v-deep .el-card__header {
                    border-bottom: none;
                    padding: 25px 25px 10px;
                }

                .login-header {
                    text-align: center;
                    margin-bottom: 10px;

                    .login-title {
                        font-size: 24px;
                        font-weight: 700;
                        color: #2e7d32;
                        margin-bottom: 8px;
                    }

                    .login-subtitle {
                        color: #666;
                        font-size: 14px;
                    }
                }

                .login-form {
                    margin-bottom: 15px;

                    .form-footer {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 10px;

                        ::v-deep .el-checkbox__label {
                            color: #666;
                            font-size: 14px;
                        }
                    }

                    .login-btn {
                        width: 100%;
                        height: 42px;
                        font-size: 15px;
                        font-weight: 600;
                        letter-spacing: 1px;
                        margin-top: 5px;
                        border-radius: 21px;
                        box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
                        transition: all 0.3s ease;
                        background-color: #4caf50;
                        border-color: #4caf50;

                        &:hover {
                            transform: translateY(-2px);
                            box-shadow: 0 6px 16px rgba(76, 175, 80, 0.4);
                            background-color: #43a047;
                        }
                    }
                }

                .footer-links {
                    text-align: center;
                    color: #666;
                    font-size: 13px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 8px;
                    padding-top: 15px;
                    border-top: 1px solid #f0f0f0;
                }
            }
        }
    }

    .copyright {
        position: relative;
        width: 100%;
        text-align: center;
        color: rgba(46, 125, 50, 0.7);
        font-size: 13px;
        padding: 15px 0;
        z-index: 1;
        flex-shrink: 0;
    }
}

// 响应式设计
@media (max-width: 992px) {
    .login-page {
        .login-content {
            padding: 15px;
        }

        .login-container {
            flex-direction: column;
            align-items: center;

            .brand-section {
                margin-bottom: 30px;
                padding: 20px;
                text-align: center;
                max-width: 500px;

                .brand-header {
                    .brand-logo {
                        justify-content: center;
                    }

                    .brand-title {
                        white-space: normal;
                        line-height: 1.3;
                    }
                }

                .features {
                    text-align: left;
                    display: inline-block;

                    li {
                        justify-content: flex-start;
                    }
                }
            }

            .login-section {
                width: 100%;
                max-width: 400px;
            }
        }
    }
}

@media (max-width: 576px) {
    .login-page {
        background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);

        .bg-decoration {
            display: none;
        }

        .login-content {
            padding: 10px;
            max-height: none;
            align-items: flex-start;
        }

        .login-container {
            flex-direction: column;
            align-items: center;

            .brand-section {
                padding: 15px 10px 10px;
                margin-bottom: 15px;

                .brand-header {
                    margin-bottom: 0;

                    .brand-logo {
                        flex-direction: column;
                        align-items: center;
                        gap: 6px;
                        margin-bottom: 8px;

                        .logo-img {
                            margin-right: 0;
                            width: 40px;
                            height: 40px;
                        }

                        .logo-text {
                            font-size: 22px;
                        }
                    }

                    .brand-title {
                        white-space: normal;
                        font-size: 18px;
                        line-height: 1.3;
                        text-align: center;
                    }
                }

                .features {
                    display: none;
                }
            }

            .login-section {
                width: 100%;
                max-width: 100%;

                .login-card {
                    max-height: none;
                    border-radius: 12px;

                    ::v-deep .el-card__header {
                        padding: 16px 16px 8px;
                    }

                    .login-header {
                        .login-title {
                            font-size: 20px;
                        }

                        .login-subtitle {
                            font-size: 13px;
                        }
                    }

                    .login-form {
                        ::v-deep .el-form-item {
                            margin-bottom: 18px;
                        }

                        ::v-deep .el-form-item__label {
                            font-size: 13px;
                        }

                        ::v-deep .el-input__inner {
                            height: 40px;
                            font-size: 14px;
                        }

                        .form-footer {
                            flex-direction: column;
                            align-items: flex-start;
                            gap: 8px;
                        }

                        .login-btn {
                            height: 44px;
                            font-size: 15px;
                        }
                    }

                    .footer-links {
                        font-size: 12px;
                        padding-top: 12px;
                    }
                }
            }
        }

        .copyright {
            font-size: 11px;
            padding: 10px 0;
        }
    }
}
</style>
